import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLazyGetTypeOfServicesQuery } from "../../../Store/Builder/schedule.api";
import { setTypeOfServices } from "../../../Store/Slice/scheduleSlice";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";

const useGetTypeOfServicesApi = () => {
  const dispatch = useDispatch();
  const [getTypeOfServices] = useLazyGetTypeOfServicesQuery();
  const lineItems = useSelector(
    (state) => state.rootReducer.scheduleSlice.line_items
  );

  const get = (data) => {
    dispatch(setLoader(true));
    getTypeOfServices(data.product_id)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        let resData = res?.map((item) => ({
          value: item?.id,
          label: item?.name,
          ...item,
        }));
        dispatch(setTypeOfServices({ id: data?.id, options: resData }));
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    get,
  };
};

export default useGetTypeOfServicesApi;
